import { makeAutoObservable } from 'mobx';

class ManagerStore {
  businessId: string;

  constructor(businessId = '') {
    this.businessId = businessId;
    makeAutoObservable(this);
  }

  getBusinessInfo() {
    return `Manager of business: ${this.businessId}`;
  }
}

export const managerStore = new ManagerStore();
